import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-settings-page",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  template: `
    <section class="dashboard">
      <div class="dashboard-main">
        <header class="dashboard-header">
          <div>
            <h1>Settings</h1>
            <p class="header-subtitle">
              Manage business defaults, estimate terms, suppliers, and email
              templates.
            </p>
          </div>
        </header>

        <div class="settings-grid">
          <a class="settings-card" routerLink="/settings/business">
            <div class="settings-card-icon">🏢</div>
            <div class="settings-card-title">Business &amp; Estimates</div>
            <div class="settings-card-desc">
              Company profile, default rates, deposit &amp; warranty, measurement
              and operation defaults.
            </div>
          </a>

          <a class="settings-card" routerLink="/settings/terms">
            <div class="settings-card-icon">📄</div>
            <div class="settings-card-title">Terms &amp; Conditions</div>
            <div class="settings-card-desc">
              Edit the terms that appear on all estimates.
            </div>
          </a>

          <a class="settings-card" routerLink="/settings/suppliers">
            <div class="settings-card-icon">🏭</div>
            <div class="settings-card-title">Suppliers</div>
            <div class="settings-card-desc">
              Create supplier accounts for the supplier portal.
            </div>
          </a>

          <a class="settings-card" routerLink="/settings/email-templates">
            <div class="settings-card-icon">✉️</div>
            <div class="settings-card-title">Email Templates</div>
            <div class="settings-card-desc">
              Edit the emails sent to customers and suppliers.
            </div>
          </a>
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .settings-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 20px;
      }
      .settings-card {
        display: block;
        text-decoration: none;
        background: var(--panel);
        border-radius: 20px;
        padding: 24px;
        box-shadow: 0 14px 32px rgba(15, 23, 42, 0.1);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        color: var(--ink-900);
      }
      .settings-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 18px 38px rgba(15, 23, 42, 0.14);
      }
      .settings-card-icon {
        font-size: 28px;
        margin-bottom: 12px;
      }
      .settings-card-title {
        font-size: 17px;
        font-weight: 700;
        margin-bottom: 8px;
      }
      .settings-card-desc {
        font-size: 13px;
        color: var(--ink-500);
        line-height: 1.5;
      }
    `,
  ],
})
export class SettingsPageComponent {}
